const internals = {};

const baseFormConfig = {
    reactHookForm: {
        mode: 'onChange',
        reValidateMode: 'onChange',
        criteriaMode: 'firstError',
        shouldFocusError: true
    },

    ui: {
        reserveHelperTextSpace: true,

        form: {
            gap: 16,
            width: '100%',
            margin: 'auto'
        },

        fieldGroup: {
            gap: 16,
            itemMinWidth: 240,
            mobileBreakpoint: 600
        },

        inlineGroup: {
            gap: 8
        },

        divider: {
            margin: '14px 0'
        },

        spacer: {
            height: 16
        },

        title: {
            marginBottom: 0
        },

        field: {
            variant: 'filled',
            size: 'small',
            margin: 'none',
            fullWidth: true,
            InputLabelProps: {
                shrink: true
            }
        },

        textField: {},

        selectField: {},

        checkboxField: {},

        emojiField: {}
    }
};

let configuredFormConfig = baseFormConfig;

internals.isPlainObject = (value) => {

    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
};

internals.mergeFormConfig = (base, override) => {

    if (!internals.isPlainObject(override)) {
        return base;
    }

    return Object.keys(override).reduce((merged, key) => {

        const baseValue = merged[key];
        const overrideValue = override[key];

        if (internals.isPlainObject(baseValue) && internals.isPlainObject(overrideValue)) {
            return {
                ...merged,
                [key]: internals.mergeFormConfig(baseValue, overrideValue)
            };
        }

        return {
            ...merged,
            [key]: overrideValue
        };
    }, { ...base });
};

internals.configureFormDefaults = (override) => {

    configuredFormConfig = internals.mergeFormConfig(configuredFormConfig, override);
    return configuredFormConfig;
};

internals.resetFormDefaults = () => {

    configuredFormConfig = baseFormConfig;
    return configuredFormConfig;
};

internals.getFormDefaults = () => configuredFormConfig;

internals.resolveFormConfig = (override) => {

    return internals.mergeFormConfig(configuredFormConfig, override);
};

module.exports = {
    baseFormConfig,
    configureFormDefaults: internals.configureFormDefaults,
    getFormDefaults: internals.getFormDefaults,
    mergeFormConfig: internals.mergeFormConfig,
    resetFormDefaults: internals.resetFormDefaults,
    resolveFormConfig: internals.resolveFormConfig
};
